import { FormPageState, SetDataActionWithoutBase } from "interface/common";
import { JoinTodayModel } from "model/view/JoinToday.model";
import { ActionType, ViewRenderStatus } from "../../util/CommonConstant";
import baseReducer, { BaseAction, BaseFormActions } from "../BaseReducer";

export type JoinTodayAction = SetDataActionWithoutBase<JoinTodayModel>;

export const INITIAL_JOINTODAY_STATE: FormPageState<JoinTodayModel> = {
  viewRenderStatus: ViewRenderStatus.SUCCESS,
  errorMessage: "",
  data: new JoinTodayModel(),
};

const JoinTodayReducer = (
  state: FormPageState<JoinTodayModel> = INITIAL_JOINTODAY_STATE,
  action: BaseAction | BaseFormActions | JoinTodayAction
): FormPageState<JoinTodayModel> => {
  const baseState = baseReducer(state, action as BaseAction);

  switch (action.type) {
    case ActionType.SET_DATA:
      return {
        ...baseState,
        data: action.payload,
      };
    case ActionType.FORCE_UPDATE:
      return {
        ...baseState,
        forceUpdate: action.payload,
      };
    default:
      return baseState;
  }
};

export default JoinTodayReducer;
